// @ts-nocheck

import { get } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Operations from '../../../operations'
import { history } from '../../../store'
import { ProPaywall } from '../ProPaywall/ProPaywall'

class ProAdvert extends Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.hasPro) this.redirect()
  }

  componentDidMount() {
    if (this.props.hasPro) {
      return this.redirect()
    }
    this.props.getHomeDetails(this.props.homeId)
  }

  redirect() {
    const excludedCheck = history.location.pathname.match(/about-me/)
    !excludedCheck && history.push('/')
  }

  render() {
    return (
      <ProPaywall title={this.props.title} subTitle={this.props.subTitle} />
    )
  }
}

ProAdvert.propTypes = {
  hasPro: PropTypes.bool,
  homeId: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  homeSource: PropTypes.string
}

const mapStateToProps = (state) => ({
  hasPro: get(state, 'global.home.pro') || false,
  homeId: get(state, 'global.home.id') || get(state, 'global.user.home')
})

const mapDispatchToProps = (dispatch) => ({
  getHomeDetails: (id) => dispatch(Operations.getHomeDetails(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(ProAdvert)
